import { render, staticRenderFns } from "./StockAdd.vue?vue&type=template&id=5914a07a&scoped=true&"
import script from "./StockAdd.vue?vue&type=script&lang=js&"
export * from "./StockAdd.vue?vue&type=script&lang=js&"
import style0 from "./StockAdd.vue?vue&type=style&index=0&id=5914a07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914a07a",
  null
  
)

export default component.exports